/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kvkkbasvuru_S2_Th_AddressInputs */

const tr_kvkkbasvuru_s2_th_address = /** @type {(inputs: Kvkkbasvuru_S2_Th_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adres / Yol`)
};

const en_kvkkbasvuru_s2_th_address = /** @type {(inputs: Kvkkbasvuru_S2_Th_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Address / Route`)
};

const de_kvkkbasvuru_s2_th_address = /** @type {(inputs: Kvkkbasvuru_S2_Th_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresse / Weg`)
};

const ru_kvkkbasvuru_s2_th_address = /** @type {(inputs: Kvkkbasvuru_S2_Th_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Адрес / способ`)
};

/**
* | output |
* | --- |
* | "Address / Route" |
*
* @param {Kvkkbasvuru_S2_Th_AddressInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kvkkbasvuru_s2_th_address = /** @type {((inputs?: Kvkkbasvuru_S2_Th_AddressInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kvkkbasvuru_S2_Th_AddressInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kvkkbasvuru_s2_th_address(inputs)
	if (locale === "de") return de_kvkkbasvuru_s2_th_address(inputs)
	if (locale === "ru") return ru_kvkkbasvuru_s2_th_address(inputs)
	return tr_kvkkbasvuru_s2_th_address(inputs)
});